module.exports = __webpack_public_path__ + "static/img/11bg_6.7b3b3b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_6.png
// module id = 625
// module chunks = 1